export class Credential {
    /**
       * Constructeur.
       * @param account : Identifiant de connexion de l'utilisateur.
       * @param password : Mot de passe de l'utilisateur.
       */
     public constructor(public account: string, public password: string) {}
  }
  